import * as THREE from 'three';
import Motor from './motor.js'
import Phobject from './Phobject.js'
export default class Drone extends Phobject{
    constructor(pos){
        super(true);
        this.build();        
        this.throttleSteps = 100;
        this.throttle = 0;
        this.quaternion = new THREE.Quaternion();
        this.targetAltitude = 0;
        this.inputFront = 0;
        this.inputBack = 0;
        this.inputLeft = 0;
        this.inputRight = 0;
        this.inputFactor = 4;
        this.inputFrontBack=0;
        this.inputLeftRight=0;
        //this.setupPhysics(pos);
    }

    canFocus(){
        return true;
    }    
    getOutlineMeshes(){
        return [this.mesh]
    }

    /*
    input affects linear velocity target
    linear velocity target is compared against actual linear velocity
    delta between target and actual LV is a vector


    If actual LV is 0,0,0, and taget is 0,1,0
    target - actual = 0,1,0
    orientation requires we level out 
    If pitched up, pitch down by throttling the back motors up
    if rolled right, roll left by throttling the 


    It's all about bending that actual linear velocity vector toward the target.
    Motors are pointed up so they determine where we go.
    If they're not pointed in the correct direction, we have to first achieve the proper orientation

    KEY: point the top toward (YET NOT AT) the linear velocity target.

    KEY: drones traditionally need to be pointed up (and can't reverse thrust), so interpolate between UP (for staying in the air) and the target linear velocity (to move where directed)

    if actual LV is 0,0,-5 and target 0,1,0 then 
    interpolate between UP and 0,1,0 => UP.
    delta => 0,1,5, so we need to throttle up on the engines that would stop our negative Z movement.
    Orientation determines which motors that is.
    This is a unit circle problem. 
    The motor(s) closest to unit circle position 0



    // Much simpler:
    drone always auto balances and input just applies an impluse to unbalance the craft (or yaw)

    Auto Balancing:
        - top needs to point up.
        - if top isn't up, calculate delta and adjust motors appropriately
        - if pitched Down, throttle up front motors.
        - if rolled right, throttle up left motors.
        - hold altitude also.
        - if we're above our target altitude, throttle all motors down
        - user 


    */

    getObject(){
        return this.group;
    }

    build(){
        this.group = new THREE.Group();

        this.buildBody();

        let e1 = this.buildEngine();
        e1.position.z = .025;
        e1.rotation.y = Math.PI/4;

        let e2 = this.buildEngine();
        e2.position.z = .025;
        e2.rotation.y = -Math.PI/4;

        let e3 = this.buildEngine();
        e3.position.z = -.025;
        e3.rotation.y = Math.PI/4 + Math.PI/2;

        let e4 = this.buildEngine();
        e4.position.z = -.025;
        e4.rotation.y = - Math.PI/4 - Math.PI/2;

        this.group.add(e1);
        this.group.add(e2);
        this.group.add(e3);
        this.group.add(e4);
        
    }
    
    setupPhysics(pos){
        this.group.position.copy(pos);
        // physics
        var options = {
            type:'box',
            size:[.25, .06, .25],
            pos:[pos.x,pos.y,pos.z],
            density:5,
            move:this.move
        }
    
        this.phobject = this.world.add( options );
        
        let armDim = .10;
        this.fl=new Motor(new THREE.Vector3(-armDim,0,-armDim), this.group.position, this.group.quaternion);
        this.fr=new Motor(new THREE.Vector3(armDim,0,-armDim), this.group.position, this.group.quaternion);
        this.bl=new Motor(new THREE.Vector3(-armDim,0,armDim), this.group.position, this.group.quaternion);
        this.br=new Motor(new THREE.Vector3(armDim,0,armDim), this.group.position, this.group.quaternion);
    }

    yawLeft(){

    }
    yawRight(){

    }
    pitchUp(){
        // apply an impulse down on the very back
        //this.fl.throttleUp();
        //this.fr.throttleUp();   
        this.inputFrontBack=this.inputFactor;
    }
    pitchdown(){
        //this.bl.throttleUp();
        //this.br.throttleUp();
        this.inputFrontBack=-this.inputFactor;
    }
    throttleUp(){
        this.targetAltitude+=.5;       
    }
    throttleDown(){
        this.targetAltitude-=.5;
        if(this.targetAltitude<0)
            this.tragetAltitude = 0;
    }
    rollRight(){
        this.inputLeftRight=this.inputFactor;
    }
    rollLeft(){
        this.inputLeftRight=-this.inputFactor;
    }
    simulate(delta){


        let targetRate = .05;
        // calculate a target orientation
        let target = new THREE.Vector3(-this.inputLeftRight*targetRate,1,-this.inputFrontBack*targetRate);
        target.normalize();

        // calculate delta between up and orientation
        //let correction = new THREE.Vector3(0,1,0);
        target.applyQuaternion(this.phobject.getQuaternion());
        // the rotation.y of the drone isn't being considered.
        //If you press S, then no matter which engines are toward the positive Z, they lose throttle

        let orientationRate = .1;
        let pitch = target.z;
        let roll = target.x;
        let front=0, back=0, left=0, right=0;

        pitch *= 100;
        roll *= 100; 
        let pitchCorr = pitch*Math.abs(pitch) * orientationRate;
        let rollCorr = roll*Math.abs(roll)* orientationRate
        pitch /= 100;
        roll /= 100; 

        front=-pitchCorr;
        back=pitchCorr;
        right=rollCorr;
        left=-rollCorr;

        front/=10;
        back/=10;
        right/=10;
        left/=10;
        
        let maxThrottle = 4.7;

        this.throttleRate = 10
        let epsilon = .05;
        let pos = this.phobject.getPosition();
        let altDiff = Math.abs(this.targetAltitude - pos.y);
        
        this.phobject.angularVelocity.y=0;
        this.phobject.angularVelocity.z=0;
        
        if(pos.y < this.targetAltitude - epsilon){
            let inc = this.throttleRate * altDiff*altDiff* altDiff;            
            this.throttle+=inc;

            if(this.throttle>maxThrottle)
                this.throttle = maxThrottle;
        }
        if(pos.y > this.targetAltitude + (epsilon*2)){
            let dec = this.throttleRate * altDiff*altDiff;
            this.throttle= maxThrottle- dec;
            if(this.throttle<0)
            this.throttle=0;
        }

        let damping = .9;
        this.inputFrontBack *= damping;
        this.inputLeftRight *= damping;

        this.fl.setThrottle( this.throttle , (front + left));
        this.fr.setThrottle( this.throttle , (front + right));
        this.bl.setThrottle( this.throttle , (back + left));
        this.br.setThrottle( this.throttle , (back + right));
        
        this.applyForces();

        super.simulate(delta)
        //this.group.position.copy( pos);        
        //this.group.quaternion.copy( this.physDrone.getQuaternion() );
        
        //console.log(this.physDrone.linearVelocity);
        //console.log(this.physDrone.angularVelocity);
        
    }
    applyForces(){        
        this.phobject.applyImpulse( this.fl.getImpulsePosition(), this.fl.getImpulseForce() );
        this.phobject.applyImpulse( this.fr.getImpulsePosition(), this.fr.getImpulseForce() );
        this.phobject.applyImpulse( this.bl.getImpulsePosition(), this.bl.getImpulseForce() );
        this.phobject.applyImpulse( this.br.getImpulsePosition(), this.br.getImpulseForce() );
    }

    buildBody(){
        //var texture = new THREE.TextureLoader().load( require('../assets/crate.gif') );
        var geometry = new THREE.BoxBufferGeometry( .075, .04, .2 );
        var material = new THREE.MeshPhongMaterial( {color: 0x222222, side: THREE.DoubleSide});
        this.mesh = new THREE.Mesh( geometry, material );
        this.mesh.position.y = .025;
        //mesh.position.z = 
        this.group.add(this.mesh);
        this.mesh.userData = this;
    }

    buildEngine(){
       
        let armLength = .2;
        let eGroup = new THREE.Group();
        var geometry = new THREE.CylinderGeometry( .075, .075, .05, 25, 2, true );
        var material = new THREE.MeshPhongMaterial( {color: 0x000000, side: THREE.DoubleSide});
        let meshNacell = new THREE.Mesh( geometry, material );
        meshNacell.position.z = armLength;
        meshNacell.position.y = .025;

        var geoArm = new THREE.BoxBufferGeometry( .015, .05, armLength );
        let meshArm = new THREE.Mesh( geoArm, material );
        meshArm.position.z = armLength/2;

        eGroup.add(meshNacell);
        eGroup.add(meshArm);
        
        return eGroup;
    }



}